import { useState } from 'react'
import { ChevronUp, ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils/helpers'
import type { CollapsibleSectionProps } from '../../types'
import styles from '../../styles/reimbursementDetail.module.css'

/**
 * Collapsible section wrapper with accordion drawer header, record count badge,
 * and toggle icon matching Reimbursement Detail design parity.
 */
export function CollapsibleSection({
  title,
  icon,
  recordCount,
  defaultOpen = true,
  children,
  className,
  testId,
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <section
      className={cn(styles.collapsibleSectionCard, className)}
      data-testid={testId}
    >
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={cn(styles.collapsibleHeaderBtn, !isOpen && styles.collapsibleHeaderBtnCollapsed)}
        aria-expanded={isOpen}
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        <div className={styles.collapsibleTitleGroup}>
          {icon ? <span className={styles.collapsibleIconWrapper}>{icon}</span> : null}
          <h2 className={styles.collapsibleTitleText}>{title}</h2>
          {recordCount !== undefined ? (
            <span className={styles.collapsibleRecordCount}>
              {recordCount} {recordCount === 1 ? 'record' : 'records'}
            </span>
          ) : null}
        </div>
        <span className={styles.collapsibleChevronWrapper}>
          {isOpen ? (
            <ChevronUp className="h-5 w-5 stroke-[2.25] text-[#1597ff]" />
          ) : (
            <ChevronDown className="h-5 w-5 stroke-[2.25] text-slate-500" />
          )}
        </span>
      </button>

      {isOpen ? (
        <div className={styles.collapsibleBody} data-testid={testId ? `${testId}-content` : undefined}>
          {children}
        </div>
      ) : null}
    </section>
  )
}
